import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const IconHouse = props => (
  <SvgIcon {...props} viewBox="0 0 18 16">
    <path d="m17 0h-16v2h16v-2zm1 10v-2l-1-5h-16l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4h-6v-4h6v4z" />
  </SvgIcon>
);

export default IconHouse;



// WEBPACK FOOTER //
// ./src/components/icons/IconHouse.js